import { render, staticRenderFns } from "./WhiteLabelHeader.vue?vue&type=template&id=f6bc7e04&scoped=true"
import script from "./WhiteLabelHeader.vue?vue&type=script&lang=js"
export * from "./WhiteLabelHeader.vue?vue&type=script&lang=js"
import style0 from "./WhiteLabelHeader.vue?vue&type=style&index=0&id=f6bc7e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6bc7e04",
  null
  
)

export default component.exports